import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Row } from "reactstrap";
import {
  getExpectedFileTypes,
  isValidFileType,
} from "../../../constants/mediaTypes";
import AddNewMedia from "../../../views/app/media/AddNewMedia";
import MediaListView from "../../../views/app/media/MediaListView";
import { Colxx } from "/@src/components/common/CustomBootstrap";
import { getMedia } from "/@src/constants/mediaTypes";
import { listMedia } from "/@src/redux/media/actions";

function SelectMedia({ confirmSelected, type, allowedType }) {
  const dispatch = useDispatch();
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [error, setError] = useState("");
  const [canUseMedia, setCanUseMedia] = useState(false);
  const [showAddNewMedia, setShowAddNewMedia] = useState(false);
  const { mediaList, listMediaLoading } = useSelector((state) => state.media);

  const allowedFileType = allowedType ? allowedType : {};

  const onUploadCancel = () => {
    setShowAddNewMedia(false);
  };

  const confirmMedia = () => {
    confirmSelected(selectedMedia);
  };

  const getAllowedFileType = () => {
    const validMedia = getMedia("", allowedFileType, type);
    return validMedia ? validMedia.allowedType : {};
  };

  const handleSelectMedia = (media) => {
    setError("");
    setCanUseMedia(false);

    if (!media) return;
    setSelectedMedia(media);
    const { fileName, mimeType } = media;
    const mediaParams = {
      url: fileName,
      mimeType,
      mediaType: type,
      allowedTypesArr: allowedType,
    };

    const isValidFile = isValidFileType(mediaParams);
    const expectedFormats = getExpectedFileTypes(mediaParams);
    const formats = expectedFormats?.join(", ");

    const errorMsg = (
      <span>
        Incorrect file type
        {formats && (
          <>
            <br />
            Expected file formats: {formats}.
          </>
        )}
      </span>
    );

    if (!isValidFile) {
      setError(errorMsg);
    } else {
      setCanUseMedia(true);
      confirmSelected(media);
    }
  };

  const onUpload = (res) => {
    dispatch(listMedia()).then(() => {
      setShowAddNewMedia(false);
      handleSelectMedia(res);
    });
  };

  const uploadNewMedia = () => {
    setError("");
    setShowAddNewMedia(true);
  };

  return (
    <div>
      <Row>
        <Colxx>
          <div className="d-flex justify-content-between">
            <div>
              <div>
                Selected Media:{" "}
                {selectedMedia ? selectedMedia.fileName : "Not Selected"}
              </div>
              <div>
                Size: {selectedMedia ? selectedMedia.fileSizeKb : "0"} Kb
              </div>
              {error && <div className="error-msg my-2">{error}</div>}
            </div>
            {!showAddNewMedia && (
              <div className="top-right-button-container">
                {/* <Button
                  color="primary"
                  onClick={confirmMedia}
                  disabled={!canUseMedia}
                >
                  Select
                </Button> */}
                <Button
                  className="ml-2"
                  color="primary"
                  onClick={uploadNewMedia}
                >
                  New Media
                </Button>
              </div>
            )}
          </div>
        </Colxx>
      </Row>
      <div className="separator my-3"></div>
      <div className="media-list-container col-12">
        {showAddNewMedia && (
          <AddNewMedia
            allowedType={getAllowedFileType()}
            onCancel={onUploadCancel}
            onUpload={onUpload}
            type={type}
          />
        )}
        {!showAddNewMedia && (
          <MediaListView
            onMediaSelectChange={handleSelectMedia}
            selectedMedia={selectedMedia}
          />
        )}
      </div>
    </div>
  );
}

export default SelectMedia;
